// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 234 ? "801559f7" : chunkId) + "." + {"234":"a5d2c98db779bfb2","429":"cf6479d33c61e0dd","498":"fc78a566277e7a74","512":"68b27877d3cca7f8","677":"9a36ea82fdc79873"}[chunkId] + ".js";
};